export default function isPasswordValid(password = '') {
	const passwordState = {
		isLongEnough: password.length >= 15,
		hasUpperCase: /[A-Z]+/g.test(password),
		hasLowerCase: /[a-z]+/g.test(password),
		hasNumber: /\d+/g.test(password),
		hasSpecialCharacter: /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]+/g.test(password),
		doesNotHaveThreeOrMoreConsecutiveCharacters: !/(.)\1\1.*/g.test(password)
	};

	let isValid = true;
	for (let key in passwordState) {
		if (!passwordState[key]) {
			isValid = false;
		}
	}

	return {passwordState, isValid};
}
